// Formatage pur d'une liste de destinataires pour l'en-tête du lecteur.
// Extrait du composant pour être testable sans rendu - même motif que
// messagerieStatut.js.
//
// La source n'est pas homogène : l'aperçu IMAP renvoie une chaîne, le message
// complet renvoie une liste d'objets. On ne suppose donc rien de la forme.

const TIRET = '-';

export function formatAdresses(liste) {
  if (!liste) return TIRET;
  if (typeof liste === 'string') return liste.trim() || TIRET;
  if (!Array.isArray(liste)) return TIRET;

  const rendu = liste
    .map((r) => (typeof r === 'string' ? r.trim() : (r?.name?.trim() || r?.email?.trim() || '')))
    .filter(Boolean)
    .join(', ');

  return rendu || TIRET;
}
